import { render, staticRenderFns } from "./_base-alert.vue?vue&type=template&id=44defa60&scoped=true"
import script from "./_base-alert.vue?vue&type=script&lang=js"
export * from "./_base-alert.vue?vue&type=script&lang=js"
import style0 from "./_base-alert.vue?vue&type=style&index=0&id=44defa60&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44defa60",
  null
  
)

export default component.exports